export default "__VITE_ASSET__Cgu9jndN__"